import { render, staticRenderFns } from "./SystemChangeLogReadonly.vue?vue&type=template&id=44b54fea&scoped=true&"
import script from "./SystemChangeLogReadonly.vue?vue&type=script&lang=js&"
export * from "./SystemChangeLogReadonly.vue?vue&type=script&lang=js&"
import style0 from "./SystemChangeLogReadonly.vue?vue&type=style&index=0&id=44b54fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b54fea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b54fea')) {
      api.createRecord('44b54fea', component.options)
    } else {
      api.reload('44b54fea', component.options)
    }
    module.hot.accept("./SystemChangeLogReadonly.vue?vue&type=template&id=44b54fea&scoped=true&", function () {
      api.rerender('44b54fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemChangeLogReadonly.vue"
export default component.exports